import { LicenseManager } from "ag-grid-enterprise";
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";
import { AllEnterpriseModule } from "ag-grid-enterprise";
import { getEnv } from "./env";

export function setupAgGrid(): void {
  ModuleRegistry.registerModules([AllCommunityModule, AllEnterpriseModule]);

  const licenceKey = getEnv("VITE_AG_GRID_LICENCE_KEY");
  if (licenceKey) {
    LicenseManager.setLicenseKey(licenceKey);
  } else {
    console.warn(
      "[AG Grid] No licence key found. Set VITE_AG_GRID_LICENCE_KEY in .env " +
        "(local dev) or ensure the Key Vault secret is configured (deployed environments)."
    );
  }
}
